import { FaExclamationCircle } from "react-icons/fa";

const EmailCancelModal = ({ setEmailModal, setCancelModal }) => {
  return (
    <div className="modal-cancel-background">
      <div className="cancel-modal-container">
        <div className="cancel-modal-header">
          <FaExclamationCircle style={{ width: "28px", height: "28px" }} />
        </div>
        <div className="cancel-modal-content">
          <h3>정말 취소하시겠습니까?</h3>
          <h3>지금까지 수정된 내용은 반영되지 않습니다.</h3>
        </div>
        <div className="cancel-modal-footer">
          <button
            className="cancel-footer-button"
            onClick={() => {
              setCancelModal(false);
              setEmailModal(false);
            }}
          >
            확인
          </button>
          <button
            className="cancel-footer-button"
            onClick={() => setCancelModal(false)}
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailCancelModal;
